import React from 'react';

import { Label, Link } from '@ergeon/core-components';

import { FooterMenuProps } from './types';

const FooterMenu: React.FC<FooterMenuProps> = ({ columns }) => {
  return (
    <div className="gap-8 grid grid-cols-2 md:grid-cols-3">
      {columns.map((column) => (
        <div className="flex flex-col gap-2" key={column.title}>
          <Label>{column.title}</Label>
          <ul className="space-y-2">
            {column.items.map((item) => (
              <li key={item.label}>
                <Link className="paragraph-2" href={item.href}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default FooterMenu;
